import React from "react";

export const FlexRowStretch = (props: {
  children: React.ReactNode | JSX.Element;
  style?: React.CSSProperties;
  className?: string;
}) => (
  <div
    className={`flex-row${props.className ? " " + props.className : ""}`}
    style={props.style}
  >
    {props.children}
  </div>
);

export const FlexGrow = (props: {
  children?: React.ReactNode | JSX.Element;
}) => <div style={{ flex: "flex-grow" }} children={props.children} />;

export const FlexBox = (props: {
  children?: React.ReactNode | JSX.Element;
  className?: string;
  style?: React.CSSProperties;
}) => (
  <div
    style={{ flex: "fit-content", margin: 0, padding: 0, ...props.style }}
    children={props.children}
  />
);

export const FlexBoxInline = (props: {
  children: React.ReactNode | JSX.Element;
  style?: React.CSSProperties;
}) => (
  <div
    style={{
      display: "flex",
      flexDirection: "row",
      margin: 0,
      padding: 0,
      ...props.style,
    }}
    children={props.children}
  />
);

export const FlexContainer = (props: {
  children?: React.ReactNode | JSX.Element;
  style?: React.CSSProperties;
}) => (
  <div
    style={{
      ...props.style,
      display: "grid",
      gridTemplateColumns: "1fr auto 1fr",
      gridTemplateRows: "25px auto 1fr",
    }}
  >
    <div
      style={{
        gridRow: "2 / 2",
        gridColumn: "2 / 3",
      }}
      children={props.children}
    />
  </div>
);

export const FlexCenter = (props: {
  children?: React.ReactNode | JSX.Element;
  style?: React.CSSProperties;
}) => (
  <div
    style={{
      ...props.style,
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "flex-start",
      gap: "2em",
    }}
    children={props.children}
  />
);

export const FlexRow = (props: {
  children?: React.ReactNode | JSX.Element;
  style?: React.CSSProperties;
}) => (
  <div
    style={{
      ...props.style,
      display: "flex",
      flexDirection: "row",
    }}
  />
);
